import { render, staticRenderFns } from "./SectionThemeChalk.vue?vue&type=template&id=69e854ce&scoped=true&"
import script from "./SectionThemeChalk.vue?vue&type=script&lang=js&"
export * from "./SectionThemeChalk.vue?vue&type=script&lang=js&"
import style0 from "./SectionThemeChalk.vue?vue&type=style&index=0&id=69e854ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e854ce",
  null
  
)

export default component.exports